export function normalizeCreatorUsername(username: string): string {
  return username.trim().replace(/^@/, '').toLowerCase();
}
